var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7639_184810",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 3,
    width: 10,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28374 20.2684C8.98874 20.5594 8.98474 21.0344 9.27574 21.3294C9.56674 21.6234 10.0417 21.6264 10.3367 21.3354L18.1147 13.6654C18.4507 13.3344 18.6357 12.8914 18.6357 12.4194C18.6357 11.9484 18.4507 11.5044 18.1147 11.1734L10.3367 3.50437C10.1907 3.36137 10.0007 3.28937 9.80974 3.28937C9.61674 3.28937 9.42274 3.36437 9.27574 3.51237C8.98474 3.80737 8.98874 4.28237 9.28374 4.57337L17.0607 12.2424C17.1267 12.3054 17.1357 12.3804 17.1357 12.4194C17.1357 12.4584 17.1267 12.5344 17.0607 12.5974L9.28374 20.2684Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7639_184810)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.8477,
    y: 24.4209,
    width: 24,
    height: 24,
    transform: "rotate(-180 24.8477 24.4209)",
    fill: "#F0F1F2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrowRightWhite.a9eaded0298de832c4a98332519954d2.svg";
export { ForwardRef as ReactComponent };